module.exports = __webpack_public_path__ + "assets/img/driver-btn-1bdf8668.png";